// Run when document content is loaded
window.addEventListener("DOMContentLoaded", () => document.documentElement.style.setProperty("--vh", `${window.innerHeight * 0.01}px`));

// We listen to the resize event
window.addEventListener("resize", () => document.documentElement.style.setProperty("--vh", `${window.innerHeight * 0.01}px`));
